import { grommet } from 'grommet';
import { deepMerge } from 'grommet/utils';
const theme = deepMerge(grommet, {
  global: {
    font: {
      family: 'Roboto',
      size: '18px',
      height: '20px'
    },
  },
  // To disable to the border.side being set to bottom
  formField: {
    border: undefined
  }
});

export default theme;